<script lang="ts">
  import { Layout } from "../../components";
  import { DataTable, DataCell, Pager, Button, Flex, FlexItem, Icon, Text } from "@gl/design-system"
  import type { Location } from "../../services/models"
  import { onMount } from "svelte"
  import { getLocations } from "../../services/endpoints"
  import { navigateCustom, navigateCustomUrl } from "../../utils/navigateCustom"
  import { _ } from "svelte-i18n"
  import { faPlus } from "@fortawesome/pro-regular-svg-icons"
  
  let table;
  let data: Location[] = [];
  let loading = true;

  onMount(() => {
    getLocations(100).then(locations => {data = locations.list; loading = false })
  })
</script>

<Layout selected="locations">
  <Flex>
    <FlexItem>
      <h3 class="gl-title level-3">{$_("common.locations")}</h3>
    </FlexItem>
    <FlexItem pushEnd={true}>
      <Button on:click={(e) => navigateCustom("/locations/create", e)}>
        <Icon icon={faPlus} />
        <Text>{$_("locations.new")}</Text>
      </Button>
    </FlexItem>
  </Flex>

  <DataTable bind:this={table} {data} {loading} {...$$restProps} let:row let:index on:change variant="separate" fullWidth selectable={false}>
    <DataCell {index} header="UUID"><a on:mouseup={(e) => navigateCustom("/locations/" + row.uuid, e)}>{ row.uuid }</a></DataCell>
    <DataCell {index} header="Tags">{ JSON.stringify(row.tags) }</DataCell>
  </DataTable>
  <Pager></Pager>
</Layout>

<style>
  .table {
    margin: 1% auto;
    font-size: 16px;
  }

  .table :global(td) {
    padding: 12px;
    text-align: left;
  }

  .table :global(button) {
    white-space: nowrap;
    box-sizing: border-box;
  }
</style>